var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M9.65405 2.33203C7.03405 2.33203 4.90405 4.46203 4.90405 7.08203C4.90405 9.65203 6.91405 11.732 9.53405 11.822C9.61405 11.812 9.69405 11.812 9.75405 11.822C9.77405 11.822 9.78405 11.822 9.80405 11.822C9.81405 11.822 9.81405 11.822 9.82405 11.822C12.3841 11.732 14.3941 9.65203 14.4041 7.08203C14.4041 4.46203 12.2741 2.33203 9.65405 2.33203Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M14.734 14.4829C11.944 12.6229 7.39401 12.6229 4.58401 14.4829C3.31401 15.3329 2.61401 16.4829 2.61401 17.7129C2.61401 18.9429 3.31401 20.0829 4.57401 20.9229C5.97401 21.8629 7.81401 22.3329 9.65401 22.3329C11.494 22.3329 13.334 21.8629 14.734 20.9229C15.994 20.0729 16.694 18.9329 16.694 17.6929C16.684 16.4629 15.994 15.3229 14.734 14.4829Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M20.644 7.67213C20.804 9.61213 19.424 11.3121 17.514 11.5421C17.504 11.5421 17.504 11.5421 17.494 11.5421H17.464C17.404 11.5421 17.344 11.5421 17.294 11.5621C16.324 11.6121 15.434 11.3021 14.764 10.7321C15.794 9.81213 16.384 8.43213 16.264 6.93213C16.194 6.12213 15.914 5.38213 15.494 4.75213C15.874 4.56213 16.314 4.44213 16.764 4.40213C18.724 4.23213 20.474 5.69213 20.644 7.67213Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M22.644 16.9224C22.564 17.8924 21.944 18.7324 20.904 19.3024C19.904 19.8524 18.644 20.1124 17.394 20.0824C18.114 19.4324 18.534 18.6224 18.614 17.7624C18.714 16.5224 18.124 15.3324 16.944 14.3824C16.274 13.8524 15.494 13.4324 14.644 13.1224C16.854 12.4824 19.634 12.9124 21.344 14.2924C22.264 15.0324 22.734 15.9624 22.644 16.9224Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }